"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M11.956 3c2.483 0 4.89.451 7.147 1.43.677.3 1.129.978 1.204 1.655v5.492a9.68 9.68 0 0 1-6.395 8.953l-.828.3a3.6 3.6 0 0 1-2.181 0l-.828-.3c-3.837-1.355-6.395-4.89-6.395-8.953V6.085c0-.677.451-1.355 1.129-1.656C7.066 3.451 9.473 3 11.956 3Zm.527 16.401c1.572-.599 6.2-2.39 6.244-7.749h-6.771V4.505A17.49 17.49 0 0 0 5.41 5.784c-.15 0-.225.15-.225.3V11.653h6.77v7.862a1.52 1.52 0 0 0 .527-.113Z"
})), "0 0 24 24", "Security");
exports.default = _default;